import SidebarLoader from "./SidebarLoader";

export default SidebarLoader;